import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Routes, Route, HashRouter } from "react-router";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import { persistor, store } from "./state";
import { SpinnerLoader } from "./components";
import { theme } from "./utils/theme";
import {
  Home,
  Password,
  PaymentList,
  PaymentNew,
  Payments,
  PaymentChoose,
  Cart,
  Entrance,
  MessagesControl,
  PurchaseSummary,
} from "./features";
import { LoadingProvider } from "./context/LoadingProvider";
import RecoverPassword from "./features/RecoverPassword";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={<SpinnerLoader />} persistor={persistor}>
          <LoadingProvider>
            <ToastContainer hideProgressBar />
            <HashRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/password" element={<Password />} />
                <Route path="/recover-password" element={<RecoverPassword />} />
                <Route path="/entrance" element={<Entrance />} />
                <Route path="/verify-entrance" element={<MessagesControl />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/summary" element={<PurchaseSummary />} />
                <Route path="/payment" element={<Payments />}>
                  <Route path="list" element={<PaymentList />} />
                  <Route path="new" element={<PaymentNew />} />
                  <Route path="choose" element={<PaymentChoose />} />
                </Route>
                {/* <Route path="*" element={<Navigate to="/" />} /> */}
              </Routes>
            </HashRouter>
          </LoadingProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
